import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { TenantProvider } from "../contexts/TenantContext";
import { DialogProvider } from "../contexts/DialogContext";

export const AssignedPlanComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<TenantProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};
